import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-veiculos-condutores',
  templateUrl: './veiculos-condutores.component.html',
  styleUrls: ['./veiculos-condutores.component.css']
})
export class VeiculosCondutoresComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
